export default {
  'settings.sectionTitle': 'Settings',
  'settings.mainButton': 'Upload new risk rules',
  'settings.title': 'Settings',
  'settings.option.manageStoreUsers': 'Manage stores users',
  'settings.finalTitle.success': 'Risk rules updated',
  'settings.finalTitle.warning': 'Rules import failed',
  'settings.finalTitle.error': 'Rules import failed',
  'settings.finalSubTitle.success': 'The risk rules were successfully updated.',
  'settings.finalSubTitle.warning': 'Please upload a file with Excel format.',
  'settings.finalSubTitle.MerchantIdError':
    'The import failed due to the following merchants having mismatch in the payment options:',
  'settings.finalSubTitle.error':
    'Please make sure you have a valid merchants IDs and country codes in your file.',
};
